import { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import EmptyState from '@/components/admin/EmptyState';
import { adminApi } from '@/lib/api';
import { format } from 'date-fns';

const niceDate = (iso) => { try { return format(new Date(iso), 'dd/MM/yyyy HH:mm'); } catch { return iso?.slice(0, 16); } };

export default function AdminActivityPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => { adminApi.activity(200).then(setItems).finally(() => setLoading(false)); }, []);
    return (
        <AdminLayout title="Actividad">
            <p className="text-sm text-muted-foreground mb-4">Bitácora de acciones administrativas recientes.</p>
            {loading ? <div className="h-64 rounded-2xl bg-white border border-border animate-pulse" /> : items.length === 0 ? <EmptyState title="Sin actividad aún" /> : (
                <div className="rounded-2xl bg-white border border-border shadow-[var(--shadow-soft)] overflow-x-auto">
                    <table className="min-w-full text-sm">
                        <thead className="bg-secondary/60 text-xs uppercase tracking-wider text-muted-foreground">
                            <tr><th className="text-left px-4 py-3">Fecha</th><th className="text-left px-4 py-3">Usuario</th><th className="text-left px-4 py-3">Módulo</th><th className="text-left px-4 py-3">Acción</th><th className="text-left px-4 py-3">Descripción</th></tr>
                        </thead>
                        <tbody className="divide-y divide-border">
                            {items.map((a) => (
                                <tr key={a.id}><td className="px-4 py-2 text-xs whitespace-nowrap">{niceDate(a.created_at)}</td><td className="px-4 py-2 text-xs">{a.user_email}</td><td className="px-4 py-2 text-xs"><span className="px-2 py-0.5 rounded-full bg-secondary border border-border">{a.module}</span></td><td className="px-4 py-2 text-xs font-medium">{a.action}</td><td className="px-4 py-2 text-xs text-muted-foreground">{a.description}</td></tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </AdminLayout>
    );
}
